import {FormControlLabel, Switch} from "@mui/material";
import {SwitchProps} from "@mui/material/Switch";
import * as React from "react";
import {AonColors} from "../../../../../css/Colors";

export interface IStyledToggle {
    toggleState: boolean;
    setToggle: (a: boolean) => void;
    selectedColor?: string;
    unSelectedColor?: string;
    label: string;
    labelPlacement?: "end" | "start" | "top" | "bottom";
}

type styledProps = IStyledToggle & Partial<SwitchProps>;

export const StyledToggle = (props: styledProps) => {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const {
        ["toggleState"]: notNeeded,
        ["setToggle"]: notNeeded1,
        ["label"]: notNeeded2,
        ["selectedColor"]: notNeeded3,
        ["unSelectedColor"]: notNeeded4,
        ["labelPlacement"]: notNeeded5,
        ...switchProps
    } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */

    const selectedColor = props.selectedColor
        ? props.selectedColor : AonColors.AonSearchTealDarkHover;
    const unSelectedColor = props.unSelectedColor
        ? props.unSelectedColor : AonColors.AonGray03;
    const switchStyle = [{
        width: 52,
        height: 24,
        padding: 0,
        "& .MuiSwitch-thumb": {
            width: 18,
            height: 18,
            transform: "translateY(-6px) translateX(-6px)",
            color: AonColors.ActualWhite
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            "& .MuiSwitch-thumb": {
                transform: "translateY(-6px) translateX(2px)",
            },
        },
        "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
            backgroundColor: selectedColor,
            opacity: 1,
        },
        "& .MuiSwitch-track": {
            backgroundColor: unSelectedColor,
            borderRadius: 20 / 2,
            opacity: 1,
        },
    }];

    return <FormControlLabel
        control={
            <Switch
                checked={props.toggleState}
                onChange={(e) => props.setToggle(e.target.checked)}
                {...switchProps}
                sx={switchStyle}
                data-testid={props.label}
            />
        }
        label={props.label}
        labelPlacement={props.labelPlacement ? props.labelPlacement : "end"}
        sx={{
            "& .MuiFormControlLabel-label": {
                margin: "0 8px",
            },
        }}
    />;
};
